export const tr = {
    'goals-loading-error': 'Kullanılabilen hedeflerin/segmentlerin listesi alınamadı. Lütfen tekrar deneyin.',
    'need-some-valid-groups':
        'Hedef kitle seçim koşulunda tahmini almak için en az bir yerine getirilmiş hedef veya segment olmalı.',
    'saving-condition-general-error': 'Yeniden pazarlama koşulu kaydedilemedi',
    'visitors-forecast-request-error': 'Ziyaretçi tahmini geçersiz'
};
